import {
  ChangeDetectionStrategy,
  Component,
  inject,
  LOCALE_ID
} from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { Clipboard } from '@angular/cdk/clipboard';
import { Router, RouterLink } from '@angular/router';

import { Notifier } from '@app/@core/notifications';
import { MediaQueryService } from '@core/breakpoints';
import { LoginButtonComponent } from '@app/ui/components';
import { AuthState } from '@app/modules/users';

@Component({
  selector: 'landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgTemplateOutlet,
    LoginButtonComponent,
    NgClass,
    RouterLink
  ]
})
export class LandingComponent {
  private readonly mediaService = inject(MediaQueryService);
  public isLg = toSignal(this.mediaService.mediaQuery('max', 'lg'));
  public readonly isRuLanguage = 'ru' === inject(LOCALE_ID);
  public readonly currentYear = new Date().getFullYear();
  private readonly clipboard = inject(Clipboard);
  private readonly notifier = inject(Notifier);
  public readonly authState = inject(AuthState);
  public readonly signInText = $localize`:@@landing.logged.button:Регистрируйся и Играй`;
  private readonly router = inject(Router);

  public readonly skinsText = $localize`:@@landing.1000skins:1000 скинов`;
  public readonly battleEventText = 'battle event';
  public readonly battleSkinstText = $localize`:@@landing.battle.skins:батл скинов`;

  copyCode(code: string): void {
    this.clipboard.copy(code);
    this.notifier.success($localize`:@@referrals.profile_widget.code_copied:Код скопирован!`);
  }

  get secondLanding(): boolean {
    return this.router.url.startsWith('/landing2');
  }

  ngOnInit() {
    if (this.authState.isAuthenticated() && !this.secondLanding) {
      this.router.navigate(['/']);
    }
  }
 
}
